'use strict';

require("moduleFold/middleware/scripts/index.js");
require("moduleFold/notifiche/scripts/index.js");
require("moduleFold/datasource/scripts/index.js");
require("moduleFold/grid/scripts/index.js");
require("moduleFold/formbuilder/scripts/index.js");
require("moduleFold/toolbar/scripts/index.js");
require("moduleFold/usermanager/styles/usermanager.scss");

var bssusermanager = angular.module("bss.usermanager", ["bss.datasource", "bss.griglia", "bss.middleware", "bss.traduzioni", "bss.notifiche", "bss.toolbar"])
    .service("UsermanagerSrv", ['ToolbarSrv', 'ActionFactory', '$http', '$q', '$timeout', "$translate", "ErrorManager", require("./UsermanagerSrv")])
    .config(["$stateProvider", "$urlRouterProvider", "$locationProvider", require("./routes/UsermanagerRoutes")])
;

module.exports = bssusermanager;
